import type { Scope as SentryScope } from '@sentry/core';

let isolatedSentryScope: SentryScope | undefined;

export const setIsolatedSentryScope = (scope: SentryScope | undefined): void => {
	isolatedSentryScope = scope;
};

export const getIsolatedSentryScope = (): SentryScope | undefined => {
	return isolatedSentryScope;
};
